export const alphanumericRegex = /^[a-zA-Z0-9]+$/;
export const alphanumericSpacesHyphensUnderscoreRegex = /^[a-zA-Z0-9 _-]*[a-zA-Z0-9_-]+[a-zA-Z0-9 _-]*$/;
export const alphanumericWithSpacesRegex = /^[a-zA-Z0-9 ]+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const domainRegex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;
export const printableAsciiRegex = /^[\x20-\x7E]+$/;